<template>
  <w-settings-content-template>
    <el-row type="flex" :gutter="40" slot="content">
      <el-col>
        <w-metering-form></w-metering-form>
      </el-col>
      <el-col>
        <w-metering-help-view></w-metering-help-view>
      </el-col>
    </el-row>
  </w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WMeteringForm from './components/MeteringForm';
import WMeteringHelpView from './components/MeteringHelpView';

export default {
  name: 'WServerVirtualization',
  components: {
    WSettingsContentTemplate,
    WMeteringForm,
    WMeteringHelpView,
  },
  data() {
    return {};
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/Metering/ServerVirtualization/index.vue